export const maxFileSize = 20 * 1024 * 1024; // = 20MB
